/**
 * Allinea il control panel Google 3D sotto la barra AuthControllerWindy,
 * come il ControlPanelLaterale su Leaflet (sotto barraNavigazione + margin 10px interno).
 */
export function syncControlPanelWindyPosition() {
    const navbar = document.querySelector('.barraNavigazioneWindy');
    const controlPanel = document.querySelector('.ControlPanelWindy');

    if (!controlPanel) {
        return;
    }

    if (!navbar || getComputedStyle(navbar).display === 'none') {
        controlPanel.style.top = '0px';
        return;
    }

    const marginTop = parseFloat(getComputedStyle(navbar).marginTop) || 0;

    if (marginTop < 0) {
        controlPanel.style.top = '0px';
        return;
    }

    controlPanel.style.top = `${navbar.offsetHeight}px`;
}
